/**
 * @file Fills the individual profile field with the investor's most
 * recent existing profile.
 */
import {
  INVESTMENT_PROFILE_FIELD_MAP,
  INVESTMENT_PROFILE_TYPE_INDIVIDUAL,
} from "@components/Domain";

import type { Form, ProfileField, ProfilesMap } from "../types";

const SUPPORTED_PROFILE_TYPES = [
  INVESTMENT_PROFILE_TYPE_INDIVIDUAL,
];

/**
 * Fills the supported profile type's field with the investor's most
 * recent existing profile of that type, when one exists.
 */
const setDefaultProfile = (form: Form, profileType: string | undefined, profilesMap: ProfilesMap): void => {
  const isSupported = SUPPORTED_PROFILE_TYPES.includes(profileType);

  if (!isSupported) {
    return;
  }

  const profileField = INVESTMENT_PROFILE_FIELD_MAP[profileType] as ProfileField;

  const existingProfiles = profilesMap[profileType];
  const hasProfiles = existingProfiles.length > 0;

  if (!hasProfiles) {
    return;
  }

  const [ recentProfile ] = existingProfiles;

  const profile = {
    ...recentProfile[profileField],
  };

  form.setFieldsValue({
    [profileField]: profile,
  });
};

export default setDefaultProfile;
